import { useEffect, useRef, useState } from 'react';
import SuperAdminIcon from '../layout/SuperAdminIcon';

const RowActions = ({ label = 'record', actions = [] }) => {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);
  const triggerRef = useRef(null);
  useEffect(() => {
    if (!open) return undefined;
    const close = (event) => {
      if (event.key === 'Escape') { setOpen(false); triggerRef.current?.focus(); }
      if (event.type === 'mousedown' && !rootRef.current?.contains(event.target)) setOpen(false);
    };
    document.addEventListener('keydown', close);
    document.addEventListener('mousedown', close);
    return () => { document.removeEventListener('keydown', close); document.removeEventListener('mousedown', close); };
  }, [open]);
  const visible = actions.filter(Boolean);
  if (!visible.length) return null;
  return <div className="sa-row-actions" ref={rootRef}><button ref={triggerRef} className="sa-icon-button" type="button" aria-haspopup="menu" aria-expanded={open} aria-label={`Actions for ${label}`} onClick={() => setOpen((value) => !value)}><SuperAdminIcon name="more" /></button>{open ? <div className="sa-row-actions__menu" role="menu">{visible.map((action) => <button key={action.label} role="menuitem" type="button" className={action.danger ? 'is-danger' : ''} disabled={action.disabled} onClick={() => { setOpen(false); action.onSelect?.(); }}>{action.label}</button>)}</div> : null}</div>;
};

export default RowActions;
